export const ManagementSkills = [
 {
    title: 'Career Growth',
    catchPhrase: 'Careers Grown',
    description: "With a focus on growing the team through communication and collaboration to help each other reach new goals. Most recently, I identified that the team would benefit by holding themselves accountable by sharing when they expect to be complete with an agile task. This allowed other engineers to pinpoint struggles early on and come to the rescue before deadlines start to slip. This led to the team improving throughput by 25% each sprint.",
    image:  require('../assets/Career_Growth.png'),
 },
 {
    title: 'Impediment Reliever',
    catchPhrase: 'Team Sentry',
    description: 'Maintained team 2 week agile cycles with taking on the roles of scrum master, solution architect, QA tester, code approver, release owner, UI/UX leader, securities expert, product owner, client relationships manager, and backend supporter. Having the ability to jump in where necessary and when needed to ensure that project timelines are met.',
    image:  require('../assets/Removing_Blockers.png'),
 },
 {
    title: 'Hiring Talent',
    catchPhrase: 'Coding Assessment',
    description: 'Established CodePen Assessment given to prospecting employees that passed initial HR phone assessment. The test involved a picture that the user would have to replicate with appropriate styles and fully functioning stock input and response of relevant stock information. This will identify if individual is a Junior or Senior level Engineer based on the code quality, a11y implementation, and error-handling.',
    image:  require('../assets/CodePen_Example.png'),
 },
 {
    title: 'Scrum Master',
    catchPhrase: 'Team Facilitator',
    description: 'I take pride in creating meaningful Retrospectives for the team so they get to know one another and learn from past experiences. Trained on running epic envisioning, sprint planning, and daily standups for the team.',
    image:  require('../assets/Sprint_Retro.png'),
 },
 {
    title: 'Documentation Expert',
    catchPhrase: 'Onboarding Guide',
    description: 'Created onboarding documentation in Atlassian Confluence to assist new hires to get up to speed quickly. I have also included a API troubleshooting guides for common issues that engineers would run into and how to resolve them.',
    image:  require('../assets/Onboarding.png'),
 },
 {
    title: 'Software Tools Integrator',
    catchPhrase: 'Tools Of The Trade',
    description: 'Known for learning and sharing experiences in various tools such as tracking team sprint health with Jira reports and dashboards, understanding various analytical tools like Grafana and Kibana, and mastering Microsoft Office Suite and Google Workspace.',
    image:  require('../assets/Tools.png'),
 }
];